import { Injectable, inject } from '@angular/core';
import { HttpService } from '@utils/http.service';
import { UtilsService } from '@utils/utils.service';

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  private http = inject(HttpService);
  private utils = inject(UtilsService);

  public bingPhotoDay = async () =>
    await this.http
      .get(`/v1/catalog/bing-photo-day`, false, false, false)
      .then((response: any) => response)
      .catch((error: any) => error);

  public getStates = async () =>
    await this.http
      .get(`/v1/catalog/states`, false)
      .then((response: any) => response.data.content.sort())
      .catch((error: any) => error);

  public getMunicipalities = async (state: string) =>
    await this.http
      .get(`/v1/catalog/states/municipality/${state}`, false)
      .then((response: any) => response.data.content.sort())
      .catch((error: any) => error);

  public getMunicipality = async (stateCode: string) =>
    await this.http
      .get(`/v1/catalog/states/municipality/${stateCode}`)
      .then((response: any) => this.utils.orderArrayBy(response.data.content, 'label'))
      .catch((error: any) => error);

  public getPermissionsList = async () => await this.http.get(`/v1/catalog/permission`).then((response: any) => this.utils.orderArrayBy(response.data.content, 'label'));
}
